import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import _ from 'lodash';
import { ClientLoggerService } from '../../services/client-logger.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { MySynchEnumerationService } from '../../services/mysynch.enumeration.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import {AdminUser, PerformanceContext} from '../../interfaces/mysynch.interfaces'; 
import { PerformanceContextService } from '../../services/performance-context.service';



@Component({
    standalone: false,
    selector: 'admin-user-management',
    templateUrl: '../app/pages/admin-user-management/admin-user-management.view.html',
    styleUrls: ['../app/pages/admin-user-management/admin-user-management.style.css']
    })
export class AdminUserManagement implements OnInit , OnDestroy{

    private updatePermissionCode:string = 'ADMIN_USER_MANAGEMENT_UPDATE';
    private performanceContext: PerformanceContext | null = null;

    private editAdminStateName:string = "AdminUserManagementMaint"; 
     
    isMobile:boolean = false;
    hasUpdatePermission: boolean = false;
    loading:boolean = true;

    adminUsers: AdminUser[] = [];
    _: any = _;
   

     constructor(@Inject('MySynchFactory') private MSF:any,
                 @Inject('ApiFactory') private api:any,
                 @Inject('ViewAuthorizationFactory') private viewAuth:any,
                 @Inject('CookieFactory') private cookies:any,
                 @Inject(MySynchEnumerationService) private mySynchEnumSvc:MySynchEnumerationService,
                 @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                 @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
                @Inject(ClientLoggerService) private log:ClientLoggerService
    ){
        this.isMobile = deviceDetector.isMobile();
    }

    ngOnInit() {
        this.MSF.ready(() => {
                this.performanceContext = this.perfContextSvc.createPerformanceContext();
            	this.perfMetricSvc.startTiming('Page:AdminUserDashboard:Render');
				this.hasUpdatePermission = this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumeration('Permission',this.updatePermissionCode));
				this.refresh().then(() => {
					this.perfMetricSvc.markPageReady('Page:AdminUserDashboard:Render', this.performanceContext);
				});
        });
    }

    ngOnDestroy() {
        this.performanceContext = null;
        
    }

    private refresh() {
        return new Promise<void>((resolve, reject) => {
           
            this.loading = true;
            this.adminUsers = [];
            
            this.perfMetricSvc.startTiming('Page:AdminUserDashboardGetAllAdminUsers:Request');
            this.api.getAllAdminUsers(this.performanceContext, (err:any,data:any) => {
                this.perfMetricSvc.endTiming("page",'Page:AdminUserDashboardGetAllAdminUsers:Request', this.performanceContext);
    
                this.loading = false;

                if (err) {
                    this.log.error(this.MSF.notify.danger('unable to get admin users: ' + err));
                    resolve();
                    return;
                }
                this.perfMetricSvc.startTiming('Page:AdminUserDashboard:Build');
                this.adminUsers = _.clone(data);
                this.adminUsers = _.map(this.adminUsers,(adminUser) => {

                    let adminUserFirstName = _.get(adminUser,'firstName',"");
                    if(_.isNull(adminUserFirstName)){ adminUserFirstName = "";};
                    let adminUserLastName = _.get(adminUser,'lastName',"");
                    if(_.isNull(adminUserLastName)){ adminUserLastName = "";};

                

                    // building Territory from lastName field. 
                    
                    const territoryStart = _.indexOf(adminUserLastName,"(");
                    const territoryEnd = _.indexOf(adminUserLastName,")");

                    if(territoryStart > -1 && territoryEnd > -1){
                        const territory = adminUserLastName.substr(territoryStart + 1,territoryEnd - (territoryStart+1)); 
                    _.set(adminUser,'territory',territory)
                    adminUserLastName = adminUserLastName.substr(0,territoryStart - 1);
                    }


                    
                    // building full name from first and last name  
                    const adminUserFullName = adminUserFirstName +" "+adminUserLastName;
                    _.set(adminUser,'fullName',adminUserFullName);


                    return adminUser;
                    
                });

                this.adminUsers = _.sortByOrder(this.adminUsers,["firstName","lastName"]);
                this.perfMetricSvc.endTiming("page",'Page:AdminUserDashboard:Build', this.performanceContext);
                resolve();
            });
        });
    }
        

	editAdminUser(adminUser:AdminUser){
        this.MSF.loadPage(this.editAdminStateName,{personId: adminUser.personId});
    }

    addAdminUser() {			
        this.MSF.loadPage(this.editAdminStateName);
    }

			
}